import { Box } from '@mui/material';
import styled from 'styled-components';
import pallet from '../../../layouts/pallet';

const PageContainer = styled(Box)({
  padding: '24px',
  backgroundColor: '#f5f5f5',
  minHeight: '100vh'
});

const HeaderBox = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '24px',
  flexWrap: 'wrap',
  gap: '16px'
});

const DataGridContainer = styled(Box)({
  backgroundColor: 'white',
  borderRadius: '12px',
  padding: '16px',
  boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
  '& .MuiDataGrid-root': {
    border: 'none'
  },
  '& .MuiDataGrid-cell': {
    borderBottom: '1px solid #e0e0e0'
  },
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: '#f8f9fa',
    borderBottom: '2px solid #e0e0e0'
  },
  '& .MuiDataGrid-row:hover': {
    backgroundColor: '#f5f5f5'
  }
});

const ValidScoreWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  overflowX: 'auto',
  whiteSpace: 'nowrap',
  maxWidth: '100%',
  '&::-webkit-scrollbar': {
    display: 'none'
  },
  height: '100%'
});

const ValidScoreItem = styled(Box)({
  backgroundColor: pallet.skyBlue,
  color: pallet.blue,
  padding: '1px 8px',
  lineHeight: 3,
  borderRadius: '12px',
  fontSize: '0.8rem',
  fontWeight: 500,
  whiteSpace: 'nowrap'
});

export {
  PageContainer,
  HeaderBox,
  DataGridContainer,
  ValidScoreWrapper,
  ValidScoreItem
};
